const config = {
  serviceHost: "https://lanis.api.golanis.com/",
  stripePublicApiKey: "pk_live_EQD9DT3DjcNw01hhE6Sf0fzF00BGBPM14u"
};

export default config;
